// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"60868":"auth-suite-sdk","79383":"api-service"}[chunkId] || chunkId) + "-" + {"18461":"fe2040e8f207d85312e1","58589":"06360f86bc21ec1de6a0","59234":"3e4b20807203cc81a908","60868":"31f356c7c0f1fefad46e","79383":"6c7002c41fec87310005","79661":"a65b59da7452f5e4e6a5","96914":"12c43b17d147c74de66c"}[chunkId] + ".min.js";
};